import { formattedDate } from "../FormatDateTime/FormatDateTime";

export const termStartEndDate = (data) => {
    if (!data) return '';

    const { termYear, termNumber, dateStart, dateEnd } = data;

    return `${termYear} / ${termNumber} (${formattedDate(dateStart) || ''} - ${formattedDate(dateEnd) || ''})`;
};